// After a deploy the previous build's hashed chunks disappear, so lazy imports fail
// ("error loading dynamically imported module", "'' is not a valid JavaScript MIME type",
// "Unable to preload CSS"). Vite reports all of these as `vite:preloadError` —
// reload once to pick up the fresh build instead of crashing to the error screen.
const RELOADED_AT_KEY = 'stale-chunk-reloaded-at'

// Never call `event.preventDefault()` here. Vite's preload helper is
// `baseModule().catch(handlePreloadError)`, and `handlePreloadError` only rethrows when the event
// was *not* default-prevented. Preventing it makes the import resolve with `undefined` instead, so
// `React.lazy` reads `undefined.default` and the real cause is replaced by an opaque
// "Cannot read properties of undefined (reading 'default')" — which `isDynamicLoadError` cannot
// recognise, so it neither gets filtered out of Honeybadger nor routed to the <AppUpdated /> screen.
// Letting the original error through keeps both of those working while the reload is in flight.
window.addEventListener('vite:preloadError', () => {
  const lastReload = Number(sessionStorage.getItem(RELOADED_AT_KEY))
  // Reload at most once per minute so a genuinely broken asset can't cause a reload loop
  if (Date.now() - lastReload < 60_000) return

  sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()))
  window.location.reload()
})
